<div class="content">
  <div class="buttonRow">
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" [pageSize]="25" [showFirstLastButtons]=true></mat-paginator>
    @if (isBusy) {
      <mat-progress-spinner mode="indeterminate" class="spinner" diameter="32"></mat-progress-spinner>
    }
    <span class="spacer"></span>
    <button class="dialogButton warn-button" [disabled]="isBusy" matButton="elevated" (click)="cancel()">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Cancel</label>
      </span>
    </button>
    <button class="dialogButton primary-button" [disabled]="isBusy || !unitsSelected()" matButton="elevated" (click)="save()">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Save</label>
      </span>
    </button>
  </div>
  <table mat-table [dataSource]="datasource" class="paginatedTable bordered-table">
    <ng-container matColumnDef="select">
      <th class="checkboxCell" mat-header-cell *matHeaderCellDef>
        <mat-checkbox class="cellCheckbox" (change)="$event ? masterToggle() : null" [disabled]="isBusy"
          [checked]="selection && selection.hasValue() && isAllSelected()"
          [indeterminate]="selection && selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" class="checkboxCell">
        <mat-checkbox class="cellCheckbox" (click)="$event.stopPropagation()" [disabled]="isBusy"
          (change)="$event ? toggleRowSelection(row) : null" [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="sequence">
      <th mat-header-cell *matHeaderCellDef>Sequence</th>
      <td mat-cell *matCellDef="let record">{{ record.sequence }}</td>
    </ng-container>
    <ng-container matColumnDef="modelCode">
      <th mat-header-cell *matHeaderCellDef>Model</th>
      <td mat-cell *matCellDef="let record">{{ record.modelCode }}</td>
    </ng-container>
    <ng-container matColumnDef="sizeCode">
      <th mat-header-cell *matHeaderCellDef>Size</th>
      <td mat-cell *matCellDef="let record">{{ record.sizeCode }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="clickableRow" [class.selectedRow]="selection.isSelected(row)" mat-row
    *matRowDef="let row; columns: displayedColumns;" (click)="toggleRowSelection(row)"></tr>
  </table>
</div>
